// extracted by mini-css-extract-plugin
export var Section = "Contacts-module--Section--gBY1f";
export var Separator = "Contacts-module--Separator--3eQ0G";
export var arrowLeft = "Contacts-module--arrowLeft--x787Z";
export var arrowRight = "Contacts-module--arrowRight--BeLf4";